import {FieldConfig} from './field.config';
import {Subject} from 'rxjs';
import {SelectItem} from '../fields/filter-select/select-item';

export class FieldConfigWrapper<T> {

    public config: T;
    public source: SelectItem[];

    private updateSubject = new Subject<Partial<FieldConfig<any>>>();
    public onUpdated = this.updateSubject.asObservable();

    constructor(fieldConfig: T) {
        this.config = fieldConfig;
    }

    public updateFieldConfig(updateFieldConfig: Partial<FieldConfig<any>>) {
        Object.assign(this.config, updateFieldConfig);

        this.updateSubject.next(updateFieldConfig);
    }
}
